import { useTranslation } from 'react-i18next';

import { ContentLayout } from '../../layout/ContentLayout';
import PageMetatags from '../../layout/PageMetatags';
import WorkshopOverviewCard from './WorkshopOverviewCard';

const WorkshopOverviewPage = () => {
  const { t } = useTranslation();

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:verification.workshops.overview.meta.title')} />
      <WorkshopOverviewCard />
    </ContentLayout>
  );
};

export default WorkshopOverviewPage;
